// Pe-ratio.js
import React, { useState } from "react";
import MainCalculatorsList from './MainCalculators';
import SharedHelmet from '.././Helmet';
import RelatedLinks from '../RelatedLinks';
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
const TITLE = "Kalkulator Rasio Harga terhadap Laba - Hitung Rasio P/E Perusahaan";
const DESCRIPTION =
    "Kalkulator rasio harga terhadap laba menghitung rasio harga terhadap laba perusahaan berdasarkan harga pasar saham dan laba per saham.";
const KEYWORDS = "rasio harga terhadap laba, hitung rasio harga terhadap laba, kalkulator rasio harga terhadap laba";
const OG_URL = "https://do-calculate.com/calculator/id/pe-ratio";
function Calculator() {
    const [stockPrice, setStockPrice] = useState('');
    const [earningsPerShare, setEarningsPerShare] = useState('');
    const [peRatio, setPeRatio] = useState('');
    const [error, setError] = useState('');
    const handleCalculate = () => {
        if (!stockPrice || !earningsPerShare) {
            setError('Harap masukkan harga saham dan laba per saham dengan benar');
            setPeRatio('');
            return;
        }
        const stockPriceValue = parseFloat(stockPrice);
        const earningsPerShareValue = parseFloat(earningsPerShare);
        if (isNaN(stockPriceValue) || isNaN(earningsPerShareValue) || earningsPerShareValue <= 0) {
            setError('Harap masukkan nilai yang valid dan positif untuk harga saham dan laba per saham');
            setPeRatio('');
            return;
        }
        const peRatioValue = stockPriceValue / earningsPerShareValue;
        setPeRatio(peRatioValue.toFixed(2));
        setError('');
    };
    return (
        <div>
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL} />
            <div className="row">
                <div className="col-12 col-md-8">
                    <FirstAds />
                </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white text-center" style={{ height: '40px' }}>
                        <h1 style={{ fontSize: '17px' }}>{TITLE}</h1>
                    </div>
                    <div className="border border-light">
                        <div className="row">
                            <div>
                                <h2 style={{ fontSize: '18px' }}>Cara Menghitung Rasio Harga terhadap Laba</h2>
                                <p>
                                    Cara menghitung rasio harga terhadap laba adalah dengan rumus matematika berikut:
                                </p>
                                <p>
                                    Rasio P/E = Harga Pasar per Saham ÷ Laba per Saham
                                </p>
                                <p>
                                    Rasio harga terhadap laba digunakan untuk menghitung laba saham berbagai perusahaan, dan menunjukkan kinerja perusahaan selama 12 bulan.
                                </p>
                                <hr />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12 col-md-7 calculatorStyle">
                                <div className='p-3 mb-2 bg-success text-white'>
                                    <h2 style={{ fontSize: '16px' }}>{TITLE} </h2>
                                </div>
                                <hr />
                                <div >
                                    <div>
                                        <div className="form-group d-flex align-items-center">
                                            <b>
                                                <label className="form-label ms-2">Harga Saham</label>
                                            </b>
                                            <input
                                                type="number"
                                                placeholder="139.55"
                                                value={stockPrice}
                                                onChange={(e) => setStockPrice(e.target.value)}
                                                className="form-control"
                                                style={{ width: '150px' }}
                                            />
                                        </div>
                                        <br />
                                        <div className="form-group d-flex align-items-center">
                                            <b>
                                                <label className="form-label ms-2">Laba per Saham</label>
                                            </b>
                                            <input
                                                type="number"
                                                placeholder="4.75"
                                                value={earningsPerShare}
                                                onChange={(e) => setEarningsPerShare(e.target.value)}
                                                className="form-control"
                                                style={{ width: '150px' }}
                                            />
                                        </div>
                                        <br />
                                        <button
                                            className="btn btn-success"
                                            style={{ fontSize: '20px' }}
                                            onClick={handleCalculate}
                                        >
                                            Hitung Rasio P/E
                                        </button>
                                    </div>
                                    <br />
                                    <div>
                                        {error !== '' ? (
                                            <p className='p-3 mb-2 bg-warning text-white'>Error: {error}</p>
                                        ) : (
                                            <>
                                                {peRatio !== '' && (
                                                    <>
                                                        <p className='p-3 mb-2 bg-success text-white'>
                                                            Rasio Harga terhadap Laba: {peRatio}
                                                        </p>
                                                        <p className='p-3 mb-2 bg-info text-black'>
                                                            Langkah-langkah penyelesaian: <br />
                                                            - Bagi harga saham dengan laba per saham untuk mendapatkan rasio harga terhadap laba.
                                                        </p>
                                                    </>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <RelatedLinks />
                            <hr />
                        </div>
                    </div>
                </div>
                <div className="col" >
                    <SecondAds />
                    <br />
                    <MainCalculatorsList CalculatorsTypeId={500}></MainCalculatorsList>
                    <br />
                </div>
            </div>
            <div className="col-12 col-md-8">
                <div className="info-sections-container">
                    <div className="info-section">
                        <div className="info-section-header">
                            <h2 style={{ fontSize: "18px" }}>{TITLE}</h2>
                        </div>
                        <div className="info-section-body">
                            <p>{DESCRIPTION}</p>
                            <div>
                                <h3 style={{ fontSize: '16px' }}>Bagaimana Cara Menghitung Rasio Harga terhadap Laba?</h3>
                                <p>Rasio harga terhadap laba dihitung menggunakan rumus berikut:</p>
                                <p><strong>Rasio P/E = Harga Pasar per Saham ÷ Laba per Saham</strong></p>
                                <p>Rasio harga terhadap laba adalah metrik yang digunakan untuk mengevaluasi harga saham berdasarkan laba perusahaan. Rasio ini mencerminkan seberapa besar pasar menilai profitabilitas perusahaan selama periode waktu tertentu, biasanya satu tahun.</p>
                            </div>
                            <hr />
                            <div>
                                <h3 style={{ fontSize: '16px' }}>Cara Menggunakan Kalkulator Rasio Harga terhadap Laba</h3>
                                <p>Untuk menggunakan kalkulator rasio harga terhadap laba, masukkan nilai berikut:</p>
                                <ul>
                                    <li><strong>Harga Pasar per Saham:</strong> Harga saham saat ini di pasar.</li>
                                    <li><strong>Laba per Saham:</strong> Laba bersih perusahaan dibagi dengan jumlah saham yang beredar.</li>
                                </ul>
                                <p>Setelah memasukkan nilai-nilai ini, kalkulator akan menghitung rasio harga terhadap laba secara otomatis, membantu Anda mengevaluasi seberapa menarik saham tersebut dibandingkan dengan laba yang dihasilkannya.</p>
                            </div>
                            <hr />
                            <div>
                                <h3 style={{ fontSize: '16px' }}>Contoh Perhitungan Rasio Harga terhadap Laba</h3>
                                <p>Misalkan harga pasar per saham adalah 50 dolar dan laba per saham adalah 5 dolar. Kita gunakan rumus berikut:</p>
                                <div className='p-3 mb-2 bg-info'>
                                    <strong>Rasio P/E = Harga Pasar per Saham ÷ Laba per Saham = 50 dolar ÷ 5 dolar = 10</strong>
                                </div>
                                <p>Dengan demikian, rasio harga terhadap laba dalam contoh ini adalah 10. Artinya, investor membayar 10 dolar untuk setiap dolar laba yang dihasilkan perusahaan.</p>
                            </div>
                            <hr />
                            <div>
                                <h3 style={{ fontSize: '16px' }}>Tips tentang Perhitungan Rasio Harga terhadap Laba</h3>
                                <p>Untuk mendapatkan evaluasi yang akurat, pastikan menggunakan nilai yang benar untuk harga pasar per saham dan laba per saham. Perlu diperhatikan juga bahwa rasio harga terhadap laba dapat bervariasi berdasarkan sektor industri dan kondisi pasar. Untuk informasi lebih lanjut tentang penggunaan rasio harga terhadap laba dalam analisis keuangan, Anda dapat merujuk pada sumber berikut, yang kami gunakan dalam pengembangan kalkulator ini:</p>
                                <ul>
                                    <li><a href="https://www.investopedia.com/terms/p/price-earningsratio.asp" rel="nofollow noreferrer" target="_blank">Investopedia - Price-to-Earnings Ratio</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default Calculator;